module.exports = __webpack_public_path__ + "static/img/homePage2.d1c5326.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theme-img/homePage2.png
// module id = eba1
// module chunks = 183